import { validateRequiredField } from 'common/utils/validation.utils';

export const validateEmail = (value: string | null | undefined, fieldName = 'Email', isRequired = true): string => {
  const trimmed = (value ?? '').trim();

  if (isRequired) {
    const requiredMsg = validateRequiredField(trimmed, fieldName);

    if (requiredMsg) {
      return requiredMsg;
    }
  }

  if (/\s/.test(trimmed)) {
    return `${fieldName} must not contain spaces.`;
  }

  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(trimmed)) {
    return `${fieldName} must be a valid email address.`;
  }

  return '';
};

export const validatePassword = (password: string) => {
  if (password.length === 0) {
    return 'Password is required.';
  }

  if (password.length < 8 || !/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/[0-9]/.test(password)) {
    return 'Password does not meet requirements (8+ characters in length, at least 1 uppercase letter, at least 1 lowercase letter, and at least 1 number).';
  }

  return '';
};
